// Importación de librerías y componentes necesarios para el componente Seguimiento
import React, { Component } from "react";
import axios from "axios";
import withRouter from "../../routes/withRouter"; // Importa el componente withRouter de React Router para acceder a las props de enrutamiento
import styled from "styled-components"; // Importa styled-components para aplicar estilos al componente
import TodoDataService from '../../hooks/services'; // Importa el servicio TodoDataService

// Importación de componentes de terceros
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';


// Importación de componentes personalizados
import ModalBaseMui from "../../components/Modal_Mui";
import SeguimientoDetalle from "./Seguimiento_Detalle";
import AlertMui from "../../components/Alert_Mui";

// Importación de archivos estáticos
import './css/style.css'; // Importa el archivo de estilos CSS
import logoimagen from '../../assets/Imagenes/columba_logo.png'
import ImagenFolio from "../../assets/Imagenes/Seguimiento/folio_col.png"; // Importa una imagen

// URL de los servicios API
const UrlSeguimiento = TodoDataService.GetHostRestApi() + '/pedidocliente/seguimiento/';
const UrlConmemoracion = TodoDataService.GetHostRestApi() + '/conmemoraciones/';
const UrlOperaciones = TodoDataService.GetHostRestApi() + '/PedidoCliente/seguimiento/tareas/';
const datalogin = { email: "apicolumba@funeralescolumba.com.mx", password: "pG7-tl3[02835}4P" };
const UrlToken = TodoDataService.GetHostRestApi() + '/usuario/login/';
const UrlCaratula = TodoDataService.GetHostRestApi() + '/conmemoraciones/caratula/';

class Seguimiento extends Component {
  intervalId = null;

  // Estado inicial del componente
  state = {
    Token: '', // Token de autenticación
    ModalFolio: false, // Estado del modal para ingresar el folio
    ListOperaciones: [], // Lista de operaciones
    ModalCompartir: false, // Estado del modal para compartir
    FormSeguimiento: '', // Datos del seguimiento
    FormConmemoracion: '', // Datos de la conmemoración
    FormCaratula: { Imagen: '', Extencion: '', Nacimiento: '', Defuncion: '' }, // Datos de la carátula
    Conmemoracion: false, // Estado de la conmemoración
    form: { // Datos del formulario
      Folio: '', // Número de folio
      ApPaterno: '', // Apellido paterno
    },
    Error: '', // Mensaje de error
  }

  // Método para manejar el retorno a la página inicial
  OnClickReturn = () => {
    this.setState({
      Origen: 'Principal',
      ModalFolio: false,
      ListOperaciones: [],
      ModalCompartir: false,
      FormSeguimiento: '',
      FormConmemoracion: '',
      FormCaratula: { Imagen: '', Nacimiento: '', Defuncion: '' },
      Conmemoracion: false,
      form: {
        Folio: '',
        ApPaterno: '',
      },
      Error: '',
    });
  }

  // }

  // Método para obtener el token de autenticación
  GetPeticionToken = async () => {
    let result = '';
    await axios.post(UrlToken, datalogin)
      .then(response => {
        this.setState({ Token: 'Bearer ' + response.data.token });
        result = 'Bearer ' + response.data.token;
      })
      .catch(error => {
        console.log(error);
      });
    return result;
  }

  // Método para obtener la conmemoración
  PeticionConmemoracionGet = async (item) => {
    let Folio = this.state.form.Folio !== '' ? this.state.form.Folio : item;
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    await axios.request(UrlConmemoracion + Folio + '/144')
      .then(response => {
        this.setState({ FormConmemoracion: response.data });
      })
      .catch(error => {
        console.log(error.message);
      });
  }

  ConvertBase64ToBlob = async (Extencion, Imagen) => {
    const blob = await fetch(Extencion + ',' + Imagen);
    let imagen = URL.createObjectURL(await blob.blob());
    return imagen;
  }

  // Método para obtener la carátula
  PeticionCaratulaGet = async (item) => {
    try {
      const Folio = this.state.form.Folio !== '' ? this.state.form.Folio : item;
      axios.defaults.headers.common["Authorization"] = this.state.Token;
      const response = await axios.get(UrlCaratula + Folio);

      const { extencionFoto, foto, agnoNacimiento, agnoDefuncion } = response.data;
      const imagen = await this.ConvertBase64ToBlob(extencionFoto, foto);

      this.setState({
        FormCaratula: {
          Imagen: extencionFoto !== null ? imagen : '',
          Nacimiento: agnoNacimiento,
          Defuncion: agnoDefuncion
        }
      });

      return extencionFoto !== null ? imagen : '';
    } catch (error) {
      console.error('Error al obtener la carátula:', error.message);
      // Aquí podrías agregar lógica para manejar el error, como mostrar un mensaje al usuario.
    }
  }

  // Método para obtener las operaciones
  PeticionOperacionGet = async (item) => {
    let Folio = this.state.form.Folio !== '' ? this.state.form.Folio : item;
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    await axios.request(UrlOperaciones + Folio)
      .then(response => {
        this.setState({ ListOperaciones: response.data.map(item => ({ Label: item.tarea, id: item.operacion })) });
      })
      .catch(error => {
        this.setState({ Error: error.response.data.errores.mensaje });
        console.log(error.message);
      });
  }

  // Método para obtener el seguimiento
  PeticionSeguimientoGet = async () => {
    axios.defaults.headers.common["Authorization"] = this.state.Token;
    await axios.request(UrlSeguimiento + this.state.form.ApPaterno + '/' + this.state.form.Folio)
      .then(response => {
        this.setState({ FormSeguimiento: response.data });
        this.PeticionConmemoracionGet();
        this.PeticionCaratulaGet();
        this.PeticionOperacionGet();
      })
      .catch(error => {
        console.log(error.message);
        this.setState({ Error: error.response.data.errores.mensaje });
      });
  }

  // Método para obtener el seguimiento al compartir
  PeticionSeguimientoCompartirGet = async (Folio, ApPaterno) => {
    try {
      // Configurar la cabecera de autorización
      axios.defaults.headers.common["Authorization"] = await this.GetPeticionToken();

      // Realizar la petición a la URL de seguimiento
      const response = await axios.request(UrlSeguimiento + ApPaterno + '/' + Folio);

      // Actualizar el estado y realizar otras operaciones necesarias
      this.setState({ FormSeguimiento: response.data, form: { Folio: Folio, ApPaterno: ApPaterno } });
      this.PeticionConmemoracionGet(Folio);
      const result = await this.PeticionCaratulaGet(Folio);
      this.PeticionOperacionGet(Folio);

      return result;
    } catch (error) {
      console.log(error.message);
      this.setState({ Error: error.response.data.errores.mensaje });
      // Devolver un valor predeterminado en caso de error
      return '';
    }
  }

  // Método para mostrar el modal del folio
  ShowModalFolio = () => {
    this.setState({ ModalFolio: !this.state.ModalFolio });
  }

  // Método para mostrar el modal de compartir
  ShowModalCompartir = () => {
    this.setState({ ModalCompartir: !this.state.ModalCompartir });
  }

  // Método para mostrar el seguimiento
  ShowSeguimiento = () => {
    this.PeticionSeguimientoGet();
  }

  // Maneja el cambio de los inputs del formulario
  handleChange = async e => {
    e.persist();

if (e.target.name === 'Folio' && !/^\d{0,10}$/.test(e.target.value)) {
    // No hacer nada si es Folio y no cumple con solo números (0-10 dígitos)
} else if (e.target.name === 'ApPaterno' && !/^[a-zA-ZáéíóúÁÉÍÓÚñÑüÜäÄëËïÏöÖ\s]*$/.test(e.target.value)) {
    // No hacer nada si es ApPaterno y no cumple con solo letras y espacios
} else {
    // Si pasa todas las validaciones, actualizar el state
    await this.setState({
        form: {
            ...this.state.form,
            [e.target.name]: e.target.value
        }
    });
}

  }

  

  // Método para compartir el seguimiento
  CompartirSeguimiento = (item) => {
    window.open(item, "_blank");
  }
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  async componentDidMount() {
    this.scrollToTop();
    this.GetPeticionToken(); // Obtiene el token de autenticación
    this.intervalId = setInterval(async () => {
      await this.GetPeticionToken();
    }, 4 * 60 * 1000);
    // Verifica si se recibieron parámetros de folio y apellido paterno
    if (this.props.params.folio && this.props.params.appaterno) {
      try {
        const imagen = await this.PeticionSeguimientoCompartirGet(this.props.params.folio, this.props.params.appaterno);
        this.setState({ Origen: 'Detalle' });
        if (imagen !== '') {
          fetch(imagen)
            .then(response => response.blob())
            .then(blob => {
              const reader = new FileReader();
              reader.onload = () => {
                // Establecer la URL de datos como el valor del atributo 'content' de la etiqueta meta 'og:image'
                document.querySelector('meta[property="og:image"]').setAttribute('content', logoimagen);
              };
              reader.readAsDataURL(blob);
            })
            .catch(error => {
              console.error('Error al obtener la imagen:', error);
            });
        }
      } catch (error) {
        console.error('Error al obtener la imagen:', error);
      }
    }
  }

  componentWillUnmount() {
    // Limpia el intervalo cuando el componente se desmonta
    clearInterval(this.intervalId);
  }



  // Renderiza el componente
  render() {
    // Estilos del componente
    const StyleDragArea = styled.div`
      .btn_consultar {
        background-color: #d14081;
        color: white;
        width: 200px;
        margin: auto;
        border-radius: 6px;
        border: 1px solid #d14081;
      }
      .btn_consultar:hover {
        background-color: white;
        border: #d14081 2px solid;
        color: #d14081;
      }
      .btn_consultar:focus {
        color: white;
        background-color: #932C59;
        box-shadow: 0 0 0 1px rgb(255 39 136);
      }
      .btn_consultar:active {
        color: white !important;
        background-color: #932C5A !important;
        border-color: #932c5a !important;
      }
      .boton_amarillo_comienza {
        width: 250px !important;
        height: 49px;
        font-size: 20px;
      }
      .boton_amarillo {
        padding: 5px 22px;
        font-size: 18px;
        background-color: #FFEC00;
        color: black;
        border: none;
        border-radius: 5px;
                border: 2px solid #FFEC00 !important;

      }
      .boton_amarillo:hover {
        background-color: white !important ;
        color: black;
        border: 2px solid #FFEC00;

      }
      .boton_amarillo:not(:disabled):not(.disabled).active, 
      .boton_amarillo:not(:disabled):not(.disabled):active, 
      .show > .boton_amarillo.dropdown-toggle {
        color: #fff;
        background-color: #BFB31C;
        border-color: #938a1e;
      }
    `;




    console.log(this.state);
    return (
      <Box mb={this.state.FormSeguimiento === '' || this.state.ListOperaciones.length === 0 ? { xs: '70px !important', sm: '120px !important' } : '0px'}>

        {/* Sección para mostrar el formulario de búsqueda del folio */}
        {this.state.FormSeguimiento === '' || this.state.ListOperaciones.length === 0 ? (
          <div className="fondo_seg mt-0">

            <Container className="Contenedor1" >
              <div className="col-md-12">
                <Typography variant="h1" className="Titulo">Seguimiento</Typography>
              </div>
              <div className="container rowCont">
                <div className="row">
                  <div className="col-md-5 col-md-5P">
                    <Typography display='inline' className="card-text style_txt Subtitulo">
                      Si tienes un servicio contratado con nosotros ingresa <Typography display='inline' className="estilo_rosa">
                        aquí tu número de folio </Typography> (lo encuentras en tu comprobante de pago)
                      <Typography className="estilo_rosa" display='inline'> y el apellido </Typography > para corroborar el estatus de tu set.</Typography>
                  </div>
                  <div className="col-md-1"></div>
                  <div className="col-md-6 ">
                    <div className="lg">
                      <div style={{ fontSize: '19px' }} className="cuadro_seg">
                        <div className="form-group">
                          <Box className='Contenedor2'>
                            <Typography mt='7px' className="input_seg labels" htmlFor="input1" component="label">Ingresa No. de folio<font className="text-danger"></font> </Typography>
                            <IconButton onClick={this.ShowModalFolio} aria-label="quest">
                              <HelpOutlineIcon className="IconoQuest" />
                            </IconButton>
                          </Box>
                          <input onChange={this.handleChange} name="Folio" maxLength={10} type="text" placeholder="Número de 10 dígitos" className="form-control" id="input1" value={this.state.form.Folio} />
                        </div>
                        <div className="form-group mb-4">
                          <Typography className="input_seg labels" htmlFor="input2" component="label">Apellido del finado<font className="text-danger">*</font></Typography>
                          <input onChange={this.handleChange} name="ApPaterno" type="text" placeholder="Apellido" className="form-control" id="input2" value={this.state.form.ApPaterno} />
                          <Typography className="Obligatorio mb-1 mb-1">*Obligatorio</Typography>
                        </div>
                        {/* Muestra un mensaje de error si existe */}
                        {this.state.Error === '' ? (
                          <></>
                        ) : (
                          <Box className='Contenedor3'>
                            <AlertMui Text={this.state.Error} Time={50000} Type="error" OnChange={() => this.setState({ Error: '' })} />
                          </Box>
                        )}
                        {/* Botón para consultar el seguimiento */}
                        <div className="Contenedor4">
                          <StyleDragArea>
                            <button disabled={this.state.form.Folio !== '' && this.state.form.ApPaterno !== '' ? false : true} onClick={this.ShowSeguimiento} data-animation-in="slideInRight" type="button" className="btn btn-block btn_consultar btnG">Consultar</button>
                          </StyleDragArea>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* Modal para mostrar información sobre el folio */}
                {this.state.ModalFolio === true ? (
                  <ModalBaseMui Title='' Open={this.state.ModalFolio} FullScreen={false} OnClickClose={this.ShowModalFolio} FullWidth={true} MaxWidth='sm'
                    ContentModal={
                      <Container maxWidth='sm'>
                        <div className="modal-body pt-0">
                          <h5 className="color_ros modal-title text-center pb-3" id="exampleModalLabel">¿Dónde encuentro mi folio?</h5>
                          <Typography className="textofolio">
                            Tu número de folio se envió al correo electrónico registrado durante la compra del set. Si no cuentas
                            con el correo,<br /> comunícate al <font className="estilo_rosa"> {TodoDataService.GetNumberCall()}. </font>
                          </Typography>
                          <div className="">
                            <img src={this.state.FormConmemoracion === '' ? ImagenFolio : this.state.FormConmemoracion.fotoVideo} alt="Imagen en el Pop-up" className="img-fluid" />
                          </div>
                        </div>
                      </Container>

                    }
                  />
                ) : (
                  <></>
                )}
              </div>
            </Container>
          </div>
        ) : (
          // Si se encontraron datos de seguimiento y operaciones, muestra el componente SeguimientoDetalle
          <SeguimientoDetalle Origen={this.state.Origen} OnClickReturn={this.OnClickReturn} DataForm={this.state.form} Host={TodoDataService.GetHost()} DataCaratula={this.state.FormCaratula} CompartirSeguimiento={this.CompartirSeguimiento} ListOperaciones={this.state.ListOperaciones} DataSeguimiento={this.state.FormSeguimiento} DataConmemoracion={this.state.FormConmemoracion} ShowModalCompartir={this.ShowModalCompartir} ModalCompartir={this.state.ModalCompartir} StyleDragArea={StyleDragArea} />
        )}


      </Box>
    );
  }
}

export default withRouter(Seguimiento);
